/// <reference path='../../include.ts' />

namespace gpx_visualizer_phase2 {

	import IFileHandler = alm.io.IFileHandler;
	import CompleteFunction = alm.io.CompleteFunction;
	import ErrorFunction = alm.io.ErrorFunction;

	export class TextFileHandler implements IFileHandler {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(headers:any = null) {
			this.headers = headers;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getType():string {
			return TextFileHandler.TYPE;
		}

		public load(url:string, onComplete:CompleteFunction, onError:ErrorFunction):void {
			jQuery.ajax({
				url: url,
				type: 'GET',
				dataType: 'text',
				headers: this.headers,
			}).then(
				(data:any, textStatus:string, jqXHR:object):void => {
					onComplete(data, { textStatus: textStatus, jqXHR: jqXHR });
				},
				(jqXHR:object, textStatus:string, errorThrown:string):void => {
					onError({ jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
				}
			);

			/*
				success: (data:string):void => {
					onComplete(data);
				},
				error: (data:any):void => {
					onError('load error : ' + url);
				}
			});
			 */
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		public static TYPE:string = 'text';

		private headers:any;
	}
}
